"use client"
import Slider from "react-slick"
import "../slickslider.css"
import { getText } from "./strapi"
import { useContext } from "react"
import { Context } from "../store/store"
import { Link } from "react-router-dom"
import Dividers1 from "./Dividers1"
import Dividers2 from "./Dividers2"
import Dividers3 from "./Dividers3"

function Info({ hideProducts = false }) {
	const { globalState } = useContext(Context)
	var settings = {
		dots: false,
		infinite: true,
		speed: 100,
		slidesToShow: 3,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		arrows: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					autoplay: true,
					autoplaySpeed: 3000,
					slidesToShow: 1.04,
					dots: false,
					speed: 300,
					infinite: true,
					slidesToScroll: 1,
				},
			},
		],
	}
	return (
		<>
			{!hideProducts && <Dividers2 />}

			<div className=" pt-6 sm:pt-10 pb-16">
				{!hideProducts && (
					<>
						<div className="mx-auto  max-w-[800px] text-center px-6">
							<h2 className="text-greenBG mb-3 sm:-mb-2 ">{getText(globalState.strapi.homepage.newProducts, "newProducts")}</h2>
							<p className="pb-4 font-AndesBold text-[21px] leading-[1.3] sm:text-[27px] text-greenBG">
								{getText(globalState.strapi.homepage.newProductsText1, "newProductsText1")}
							</p>
							<p className="pb-6 font-OpenSansRegular text-[16px] leading-[1.4] sm:text-[19px] text-greenBG">
								{getText(globalState.strapi.homepage.newProductsText2, "newProductsText2")}
								<sup>1</sup>
							</p>
							<p className="font-OpenSansBold text-[16px] leading-[1.4] sm:text-[19px] text-greenBG">{getText(globalState.strapi.homepage.newProductsText3, "newProductsText3")}</p>
						</div>

						<Slider {...settings} className="mx-auto  max-w-[1122px] pt-5 sm:pt-12">
							<img src={process.env.PUBLIC_URL + "/images/sliderSectionNeu1.png"} alt="TREK Protein Oat Bar Produkt" className="w-full" />
							<img src={process.env.PUBLIC_URL + "/images/sliderSectionNeu2.png"} alt="TREK Protein Oat Bar Produkt" className="w-full" />
							<img src={process.env.PUBLIC_URL + "/images/sliderSectionNeu3.png"} alt="TREK Protein Oat Bar Produkt" className="w-full" />
						</Slider>
					</>
				)}

				<h2 className="text-greenBG pt-[71px] sm:pt-11 pb-6 sm:pb-4">{getText(globalState.strapi.homepage.sharing, "sharing")}</h2>

				<ul className="pl-0 ml-0 text-center">
					<li className="inline-block mx-4">
						<a href="https://www.instagram.com/volvic_de/" target="_blank" rel="noopener noreferrer">
							<svg className="w-[50px] sm:w-[72px] h-auto " width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clipPath="url(#clip0_13125_1595)">
									<path
										d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z"
										fill="url(#paint0_linear_13125_1595)"
									/>
									<path
										d="M45.9241 23.9463C44.7188 23.9463 43.7344 24.9307 43.7344 26.136C43.7344 27.3414 44.7188 28.3258 45.9241 28.3258C47.1295 28.3258 48.1138 27.3414 48.1138 26.136C48.1138 24.9307 47.1295 23.9463 45.9241 23.9463Z"
										fill="white"
									/>
									<path
										d="M36.1607 26.7788C31.0781 26.7788 26.9397 30.9172 26.9397 35.9998C26.9397 41.0824 31.0781 45.2208 36.1607 45.2208C41.2433 45.2208 45.3817 41.0824 45.3817 35.9998C45.3817 30.9172 41.2433 26.7788 36.1607 26.7788ZM36.1607 41.906C32.9062 41.906 30.2544 39.2543 30.2544 35.9998C30.2544 32.7453 32.9062 30.0935 36.1607 30.0935C39.4151 30.0935 42.0669 32.7453 42.0669 35.9998C42.0669 39.2543 39.4151 41.906 36.1607 41.906Z"
										fill="white"
									/>
									<path
										d="M43.4732 54.7434H28.5067C22.2991 54.7434 17.2567 49.701 17.2567 43.4934V28.5269C17.2567 22.3193 22.2991 17.2769 28.5067 17.2769H43.4732C49.6808 17.2769 54.7232 22.3193 54.7232 28.5269V43.4934C54.7232 49.701 49.6808 54.7434 43.4732 54.7434ZM28.5268 20.7925C24.2679 20.7925 20.7924 24.2679 20.7924 28.5269V43.4934C20.7924 47.7523 24.2679 51.2277 28.5268 51.2277H43.4933C47.7522 51.2277 51.2277 47.7523 51.2277 43.4934V28.5269C51.2277 24.2679 47.7522 20.7925 43.4933 20.7925H28.5268Z"
										fill="white"
									/>
								</g>
								<defs>
									<linearGradient id="paint0_linear_13125_1595" x1="10.5469" y1="10.5469" x2="61.4531" y2="61.4531" gradientUnits="userSpaceOnUse">
										<stop stopColor="#FFE185" />
										<stop offset="0.21" stopColor="#FFBB36" />
										<stop offset="0.38" stopColor="#FF5176" />
										<stop offset="0.52" stopColor="#F63395" />
										<stop offset="0.74" stopColor="#A436D2" />
										<stop offset="1" stopColor="#5F4EED" />
									</linearGradient>
									<clipPath id="clip0_13125_1595">
										<rect width="72" height="72" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</a>
					</li>
					<li className="inline-block mx-4">
						<a href="https://www.youtube.com/channel/UCArRsqDf295BpS1FPGvc83w?cbrd=1" target="_blank" rel="noopener noreferrer">
							<svg className="w-[50px] sm:w-[72px] h-auto " width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z" fill="#FF0000" />
								<path
									d="M53.4776 31.4397C53.4776 27.2009 50.0424 23.7656 45.8035 23.7656H26.1763C21.9375 23.7656 18.5022 27.2009 18.5022 31.4397V40.5804C18.5022 44.8192 21.9375 48.2545 26.1763 48.2545H45.8035C50.0424 48.2545 53.4776 44.8192 53.4776 40.5804V31.4397ZM41.9464 36.683L33.1473 41.0424C32.8058 41.2232 31.6205 40.9821 31.6205 40.5804V31.6406C31.6205 31.2388 32.8058 30.9978 33.1473 31.1987L41.5647 35.779C41.9263 35.9799 42.2879 36.4821 41.9263 36.683H41.9464Z"
									fill="white"
								/>
							</svg>
						</a>
					</li>
					<li className="inline-block mx-4">
						<a href="https://www.facebook.com/Volvic/?locale=de_DE" target="_blank" rel="noopener noreferrer">
							<svg className="w-[50px] sm:w-[72px] h-auto " width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clipPath="url(#clip0_13125_1597)">
									<path d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z" fill="#127AF6" />
									<path
										d="M39.9776 58.9219V38.8527H46.6674L47.933 30.5559H39.9776V25.1719C39.9776 22.9019 41.0826 20.692 44.6584 20.692H48.2745V13.6206C48.2745 13.6206 44.9799 13.0581 41.8459 13.0581C35.2968 13.0581 30.9977 17.0358 30.9977 24.2277V30.5559H23.7053V38.8527H30.9977V58.9219H39.9776Z"
										fill="white"
									/>
								</g>
								<defs>
									<clipPath id="clip0_13125_1597">
										<rect width="72" height="72" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</a>
					</li>
					<li className="inline-block mx-4">
						<a href="https://www.tiktok.com/@volvic_de" target="_blank" rel="noopener noreferrer">
							<svg className="w-[50px] sm:w-[72px] h-auto " width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clipPath="url(#clip0_13125_1598)">
									<path
										d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z"
										fill="url(#paint0_linear_13125_1598)"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M43.5335 30.3752C46.1451 32.2435 49.3594 33.3484 52.8148 33.3484V26.6989C52.1518 26.6989 51.509 26.6386 50.8661 26.498V31.7413C47.4107 31.7413 44.1965 30.6364 41.5849 28.7681V42.3484C41.5849 49.1386 36.0804 54.6431 29.2701 54.6431C26.7389 54.6431 24.3683 53.8797 22.4197 52.5538C24.6496 54.844 27.7634 56.2502 31.2188 56.2502C38.009 56.2502 43.5335 50.7457 43.5335 43.9556V30.3752ZM45.9442 23.6654C44.5983 22.1989 43.7344 20.3105 43.5335 18.2413V17.3774H41.6853C42.1474 20.0292 43.7344 22.2993 45.9442 23.6654ZM26.7389 47.3507C25.9956 46.3663 25.5938 45.181 25.5938 43.9355C25.5938 40.8216 28.1049 38.3105 31.2188 38.3105C31.8014 38.3105 32.384 38.3908 32.9264 38.5716V31.7614C32.2835 31.681 31.6206 31.6408 30.9777 31.6408V36.9444C30.4152 36.7636 29.8527 36.6832 29.2701 36.6832C26.1563 36.6832 23.6451 39.1944 23.6451 42.3082C23.6451 44.498 24.9108 46.4065 26.7389 47.3306V47.3507Z"
										fill="#FF1753"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M41.5848 28.7476C44.1964 30.6159 47.4107 31.7208 50.866 31.7208V26.4775C48.9375 26.0757 47.2299 25.0511 45.9442 23.6449C43.7343 22.2788 42.1674 20.0087 41.6852 17.3569H36.8437V43.9351C36.8437 47.0288 34.3125 49.54 31.2187 49.54C29.3906 49.54 27.7634 48.6761 26.7388 47.3101C24.9107 46.3859 23.6451 44.4775 23.6451 42.2877C23.6451 39.1739 26.1562 36.6627 29.2701 36.6627C29.8727 36.6627 30.4352 36.7632 30.9776 36.9239V31.6203C24.308 31.761 18.9241 37.2051 18.9241 43.915C18.9241 47.2699 20.2701 50.3034 22.4397 52.5132C24.3884 53.819 26.7589 54.6025 29.2901 54.6025C36.0803 54.6025 41.6049 49.098 41.6049 42.3078V28.7275L41.5848 28.7476Z"
										fill="white"
									/>
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M50.8661 26.4777V25.0513C49.1183 25.0513 47.4107 24.5692 45.9442 23.6451C47.25 25.0714 48.9777 26.0558 50.8661 26.4777ZM41.6853 17.3772C41.6451 17.1161 41.6049 16.875 41.5848 16.6138V15.75H34.8951V42.3281C34.8951 45.4219 32.3639 47.933 29.2701 47.933C28.3661 47.933 27.5023 47.7121 26.7389 47.3304C27.7634 48.6763 29.3906 49.5603 31.2188 49.5603C34.3125 49.5603 36.8438 47.0491 36.8438 43.9554V17.3772H41.6853ZM30.9777 31.6607V30.154C30.4152 30.0737 29.8527 30.0335 29.2902 30.0335C22.5 30.0335 16.9755 35.5379 16.9755 42.3281C16.9755 46.5871 19.1451 50.3438 22.4398 52.5536C20.2701 50.3438 18.9241 47.3103 18.9241 43.9554C18.9241 37.2455 24.288 31.8013 30.9777 31.6607Z"
										fill="#00C9D0"
									/>
								</g>
								<defs>
									<linearGradient id="paint0_linear_13125_1598" x1="10.5469" y1="10.5469" x2="61.4531" y2="61.4531" gradientUnits="userSpaceOnUse">
										<stop stopColor="#23004A" />
										<stop offset="0.96" stopColor="#010003" />
										<stop offset="1" />
									</linearGradient>
									<clipPath id="clip0_13125_1598">
										<rect width="72" height="72" fill="white" />
									</clipPath>
								</defs>
							</svg>
						</a>
					</li>
				</ul>
			</div>

			<Dividers1 />

			<div className="bg-greenBG -mt-[0.8%]">
				<p className="font-OpenSansRegular text-[14px] sm:text-[17px] leading-[1.2] text-white max-w-[800px] mx-auto px-4 py-12 sm:py-16 text-center">
					{getText(globalState.strapi.homepage.prodRecharge, "prodRecharge")}
					<br />
					<br />
					{getText(globalState.strapi.homepage.prodSport, "prodSport")}
					<br />
					<br />
					{getText(globalState.strapi.homepage.prodVitalize, "prodVitalize")}
				</p>
			</div>
		</>
	)
}

export default Info
